import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Mail, Phone, MapPin, Send } from 'lucide-react'

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  const onSubmit = async (data) => {
    setIsSubmitting(true)
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1500))
    
    // Store inquiry in localStorage
    const inquiries = JSON.parse(localStorage.getItem('shikdar_films_inquiries') || '[]')
    inquiries.push({
      ...data,
      timestamp: new Date().toISOString(),
      id: Date.now()
    })
    localStorage.setItem('shikdar_films_inquiries', JSON.stringify(inquiries))
    
    toast.success('Thank you! We will get back to you soon.')
    reset()
    setIsSubmitting(false)
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16" data-component-path="client/src/pages/Contact.jsx" data-component-line="32:4" data-component-id="client/src/pages/Contact.jsx:32:4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="33:6" data-component-id="client/src/pages/Contact.jsx:33:6">
        {/* Header */}
        <div className="text-center mb-12" data-component-path="client/src/pages/Contact.jsx" data-component-line="35:8" data-component-id="client/src/pages/Contact.jsx:35:8">
          <h1 className="section-title text-4xl md:text-5xl text-gray-900 mb-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="36:10" data-component-id="client/src/pages/Contact.jsx:36:10">
            Get In Touch
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Contact.jsx" data-component-line="39:10" data-component-id="client/src/pages/Contact.jsx:39:10">
            Have a project in mind or want to collaborate? We'd love to hear from you!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-component-path="client/src/pages/Contact.jsx" data-component-line="44:8" data-component-id="client/src/pages/Contact.jsx:44:8">
          {/* Contact Information */}
          <div data-component-path="client/src/pages/Contact.jsx" data-component-line="46:10" data-component-id="client/src/pages/Contact.jsx:46:10">
            <div className="bg-white rounded-xl shadow-md p-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="47:12" data-component-id="client/src/pages/Contact.jsx:47:12">
              <h2 className="section-title text-2xl text-gray-900 mb-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="48:14" data-component-id="client/src/pages/Contact.jsx:48:14">
                Contact Information
              </h2>
              
              <div className="flex flex-col gap-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="52:14" data-component-id="client/src/pages/Contact.jsx:52:14">
                <div className="flex items-start gap-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="53:16" data-component-id="client/src/pages/Contact.jsx:53:16">
                  <div className="w-12 h-12 bg-bengal-green rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="54:18" data-component-id="client/src/pages/Contact.jsx:54:18">
                    <MapPin className="w-6 h-6 text-white" data-component-path="client/src/pages/Contact.jsx" data-component-line="55:20" data-component-id="client/src/pages/Contact.jsx:55:20" />
                  </div>
                  <div data-component-path="client/src/pages/Contact.jsx" data-component-line="57:18" data-component-id="client/src/pages/Contact.jsx:57:18">
                    <h3 className="font-semibold text-gray-900 mb-1" data-component-path="client/src/pages/Contact.jsx" data-component-line="58:20" data-component-id="client/src/pages/Contact.jsx:58:20">Office Location</h3>
                    <p className="text-gray-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="59:20" data-component-id="client/src/pages/Contact.jsx:59:20">Dhaka, Bangladesh</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="63:16" data-component-id="client/src/pages/Contact.jsx:63:16">
                  <div className="w-12 h-12 bg-bengal-orange rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="64:18" data-component-id="client/src/pages/Contact.jsx:64:18">
                    <Mail className="w-6 h-6 text-white" data-component-path="client/src/pages/Contact.jsx" data-component-line="65:20" data-component-id="client/src/pages/Contact.jsx:65:20" />
                  </div>
                  <div data-component-path="client/src/pages/Contact.jsx" data-component-line="67:18" data-component-id="client/src/pages/Contact.jsx:67:18">
                    <h3 className="font-semibold text-gray-900 mb-1" data-component-path="client/src/pages/Contact.jsx" data-component-line="68:20" data-component-id="client/src/pages/Contact.jsx:68:20">Email Address</h3>
                    <a href="mailto:contact@shikdarfilms.com" className="text-bengal-green hover:text-bengal-orange transition-colors" data-component-path="client/src/pages/Contact.jsx" data-component-line="69:20" data-component-id="client/src/pages/Contact.jsx:69:20">
                      contact@shikdarfilms.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="75:16" data-component-id="client/src/pages/Contact.jsx:75:16">
                  <div className="w-12 h-12 bg-bengal-red rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="76:18" data-component-id="client/src/pages/Contact.jsx:76:18">
                    <Phone className="w-6 h-6 text-white" data-component-path="client/src/pages/Contact.jsx" data-component-line="77:20" data-component-id="client/src/pages/Contact.jsx:77:20" />
                  </div>
                  <div data-component-path="client/src/pages/Contact.jsx" data-component-line="79:18" data-component-id="client/src/pages/Contact.jsx:79:18">
                    <h3 className="font-semibold text-gray-900 mb-1" data-component-path="client/src/pages/Contact.jsx" data-component-line="80:20" data-component-id="client/src/pages/Contact.jsx:80:20">Phone Number</h3>
                    <a href="tel:+8801XXXXXXXX" className="text-bengal-green hover:text-bengal-orange transition-colors" data-component-path="client/src/pages/Contact.jsx" data-component-line="81:20" data-component-id="client/src/pages/Contact.jsx:81:20">
                      +880 1XXX-XXXXXX
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200" data-component-path="client/src/pages/Contact.jsx" data-component-line="88:14" data-component-id="client/src/pages/Contact.jsx:88:14">
                <h3 className="font-semibold text-gray-900 mb-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="89:16" data-component-id="client/src/pages/Contact.jsx:89:16">Business Hours</h3>
                <div className="space-y-2 text-gray-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="90:16" data-component-id="client/src/pages/Contact.jsx:90:16">
                  <p data-component-path="client/src/pages/Contact.jsx" data-component-line="91:18" data-component-id="client/src/pages/Contact.jsx:91:18">Sunday - Thursday: 9:00 AM - 6:00 PM</p>
                  <p data-component-path="client/src/pages/Contact.jsx" data-component-line="92:18" data-component-id="client/src/pages/Contact.jsx:92:18">Friday - Saturday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-xl shadow-md p-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="99:10" data-component-id="client/src/pages/Contact.jsx:99:10">
            <h2 className="section-title text-2xl text-gray-900 mb-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="100:12" data-component-id="client/src/pages/Contact.jsx:100:12">
              Send Us a Message
            </h2>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="104:12" data-component-id="client/src/pages/Contact.jsx:104:12">
              <div data-component-path="client/src/pages/Contact.jsx" data-component-line="105:14" data-component-id="client/src/pages/Contact.jsx:105:14">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="106:16" data-component-id="client/src/pages/Contact.jsx:106:16">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  {...register('name', { required: 'Name is required' })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-bengal-green focus:border-transparent transition-all"
                  placeholder="Your full name"
                  data-component-path="client/src/pages/Contact.jsx" data-component-line="110:18" data-component-id="client/src/pages/Contact.jsx:110:18"
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="117:18" data-component-id="client/src/pages/Contact.jsx:117:18">{errors.name.message}</p>
                )}
              </div>

              <div data-component-path="client/src/pages/Contact.jsx" data-component-line="121:14" data-component-id="client/src/pages/Contact.jsx:121:14">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="122:16" data-component-id="client/src/pages/Contact.jsx:122:16">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  {...register('email', { 
                    required: 'Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address'
                    }
                  })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-bengal-green focus:border-transparent transition-all"
                  placeholder="your.email@example.com"
                  data-component-path="client/src/pages/Contact.jsx" data-component-line="126:18" data-component-id="client/src/pages/Contact.jsx:126:18"
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="138:18" data-component-id="client/src/pages/Contact.jsx:138:18">{errors.email.message}</p>
                )}
              </div>

              <div data-component-path="client/src/pages/Contact.jsx" data-component-line="142:14" data-component-id="client/src/pages/Contact.jsx:142:14">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="143:16" data-component-id="client/src/pages/Contact.jsx:143:16">
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  {...register('subject', { required: 'Subject is required' })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-bengal-green focus:border-transparent transition-all"
                  placeholder="What is this regarding?"
                  data-component-path="client/src/pages/Contact.jsx" data-component-line="147:18" data-component-id="client/src/pages/Contact.jsx:147:18"
                />
                {errors.subject && (
                  <p className="mt-1 text-sm text-red-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="154:18" data-component-id="client/src/pages/Contact.jsx:154:18">{errors.subject.message}</p>
                )}
              </div>

              <div data-component-path="client/src/pages/Contact.jsx" data-component-line="158:14" data-component-id="client/src/pages/Contact.jsx:158:14">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="159:16" data-component-id="client/src/pages/Contact.jsx:159:16">
                  Message *
                </label>
                <textarea
                  id="message"
                  rows="5"
                  {...register('message', { required: 'Message is required' })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-bengal-green focus:border-transparent transition-all resize-none"
                  placeholder="Tell us about your project or inquiry..."
                  data-component-path="client/src/pages/Contact.jsx" data-component-line="163:18" data-component-id="client/src/pages/Contact.jsx:163:18"
                ></textarea>
                {errors.message && (
                  <p className="mt-1 text-sm text-red-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="170:18" data-component-id="client/src/pages/Contact.jsx:170:18">{errors.message.message}</p>
                )}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full flex items-center justify-center gap-2 bg-bengal-green hover:bg-bengal-orange text-white font-semibold px-8 h-14 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 focus:ring-4 focus:ring-bengal-green/50 disabled:opacity-50 disabled:cursor-not-allowed"
                data-component-path="client/src/pages/Contact.jsx" data-component-line="174:14" data-component-id="client/src/pages/Contact.jsx:174:14"
              >
                {isSubmitting ? (
                  <>Sending...</>
                ) : (
                  <>
                    <Send className="w-5 h-5" data-component-path="client/src/pages/Contact.jsx" data-component-line="183:20" data-component-id="client/src/pages/Contact.jsx:183:20" />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact